import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import _ from 'lodash';

import { ValueStub } from 'constants/data';
import { COMMON_DATE_FORMAT } from 'constants/date';
import { getPendingChangesAuthorLabel } from 'utils/pendingChangesAuthors';

dayjs.extend(relativeTime);

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T/;

const CURRENT_USER_SUFFIX = ' (you)';

const formatPendingChangeValue = value => {
  if (_.isNil(value) || value === '') {
    return ValueStub.ALTERNATE;
  }

  if (_.isString(value) && ISO_DATE_PATTERN.test(value)) {
    return dayjs(value).format(COMMON_DATE_FORMAT);
  }

  return String(value);
};

const getAuthorTitle = (author, authorInfo) => {
  if (authorInfo?.isAi) {
    return getPendingChangesAuthorLabel(authorInfo);
  }

  const name = authorInfo?.name || author.name || '';

  return authorInfo?.isCurrentUser ? `${name}${CURRENT_USER_SUFFIX}` : name;
};

export const buildPendingChangeAuthorRows = ({ authors, authorsByKey, colorMap }) =>
  (authors || []).map(author => ({
    key: author.key,
    color: colorMap?.[author.key] ?? null,
    title: getAuthorTitle(author, authorsByKey?.[author.key]),
    time: _.isNil(author.createdDate) ? '' : dayjs(author.createdDate).fromNow(),
    oldValue: formatPendingChangeValue(author.oldValue),
    newValue: formatPendingChangeValue(author.newValue),
  }));
